import { Sidebar } from "primereact/sidebar";
import { Tooltip } from 'primereact/tooltip';
import { useState } from "react";
import { SphereChatPanel } from "../SphereChatPanel/SphereChatPanel";

interface SpherePropertiesPanelProps {
  contextKey: string;
  canParticipate: boolean;
  conversationsEnabled?: boolean; // Add this prop so parent can pass schema check
  viewMode?: boolean; // Controls whether conversations are read-only
}

const SpherePropertiesPanel = ({ contextKey, canParticipate, conversationsEnabled = true, viewMode = false }: SpherePropertiesPanelProps) => {
  const [chatOpen, setChatOpen] = useState(false);
  
  return (
    <>
      {/* ... Sphere properties ... */}
      {canParticipate && conversationsEnabled && (
        <>
           <Tooltip target=".open-chat-button" content="Open Chat" />
          <button
            type="button"
            className="open-chat-button"
            aria-label="Open Chat"
            onClick={() => setChatOpen(true)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                setChatOpen(true);
              }
            }}
            tabIndex={0}
          >
            <i className="pi pi-window-maximize" aria-hidden="true"></i>
          </button>
        </>
      )}
      {conversationsEnabled && (
        <Sidebar
          visible={chatOpen}
          position="bottom"
          onHide={() => setChatOpen(false)}
          style={{ height: "60vh", borderRadius: "1rem 1rem 0 0" }}
        >
          <SphereChatPanel contextKey={contextKey} viewMode={viewMode} showThreadContext={false} />
        </Sidebar>
      )}
    </>
  );
}
export default SpherePropertiesPanel;